import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  getAllTenants,
  onCreateTenant,
  onDeleteTenant,
  onGetTenant,
  onUpdateTenant,
} from '../../../app/modules/base-definitions/components/tenants/core/_requests'
interface TenantState {
  tenants: any
  tenant: any
  isLoading: boolean
}
const initialState = {
  tenants: [],
  tenant: null,
  isLoading: true,
} as TenantState

export const fetchTenants = createAsyncThunk('tenant/fetchTenants', async (param: any) => {
  const data: any = await getAllTenants(param)
  return data.data.result
})

export const fetchTenantById = createAsyncThunk('tenant/fetchTenantById', async (param: any) => {
  const data: any = await onGetTenant(param)
  return data.data.result
})

export const updateTenant = createAsyncThunk('tenant/updateTenant', async (param: any) => {
  const data: any = await onUpdateTenant(param)
  return data.data
})

export const createTenant = createAsyncThunk('tenant/createTenant', async (param: any) => {
  const data: any = await onCreateTenant(param)
  return data.data
})

export const deleteTenant = createAsyncThunk('tenant/deleteTenant', async (param: any) => {
  const data: any = await onDeleteTenant(param)
  return data.data
})

const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    clearTenants: (state) => {
      state.tenants = []
    },
    clearTenant: (state) => {
      state.tenant = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTenants.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchTenants.fulfilled, (state: any, action) => {
      state.tenants = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchTenants.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchTenantById.fulfilled, (state: any, action) => {
      state.tenant = action.payload
    })
  },
})

export const {clearTenants, clearTenant, activateLoading} = tenantSlice.actions

export default tenantSlice.reducer
